const DEFAULT_THEME = {
  name: 'default',
  palette: {
    primaryColor: {
      10: '#f2f8ff',
      20: '#e6f2ff',
      30: '#add5ff',
      40: '#73b9ff',
      50: '#3a9dff',
      60: '#0080ff',
      70: '#006dd9',
      80: '#005ab3',
      90: '#00468c',
      100: '#003366',
    },
    secondaryColor: {
      10: '#ffe6f1',
      20: '#ffb8d7',
      30: '#ff8abe',
      40: '#ff5ca4',
      50: '#ff2e8b',
      60: '#ff0071',
      70: '#d90065',
      80: '#b30058',
      90: '#8c004c',
      100: '#66003f',
    },
    accentColorV1: {
      10: '#fefbf0',
      20: '#fff7e0',
      30: '#ffeba8',
      40: '#ffdf70',
      50: '#fed238',
      60: '#fec601',
      70: '#d8a901',
      80: '#b28b01',
      90: '#8c6e00',
      100: '#665000',
    },
    accentColorV2: {
      10: '#f9f4fc',
      20: '#f3e8fc',
      30: '#d9bef1',
      40: '#c293e5',
      50: '#aa69da',
      60: '#913ece',
      70: '#7f36b4',
      80: '#6d2f9a',
      90: '#5a2780',
      100: '#481f66',
    },
    accentColorV3: {
      10: '#e8e6ff',
      20: '#cecaf5',
      30: '#b4aeeb',
      40: '#9992e0',
      50: '#7f76d6',
      60: '#655acc',
      70: '#5750b3',
      80: '#494699',
      90: '#3b3c80',
      100: '#2d3266',
    },
    accentColorV4: {
      10: '#f5fcf8',
      20: '#e6f7ed',
      30: '#b5e2cb',
      40: '#83cca9',
      50: '#52b786',
      60: '#20a164',
      70: '#1d925b',
      80: '#1a8452',
      90: '#177548',
      100: '#14663f',
    },
    accentColorV5: {
      10: '#fff7f8',
      20: '#ffebef',
      30: '#f8bbc5',
      40: '#f18c9d',
      50: '#e95d75',
      60: '#e22d4c',
      70: '#c32742',
      80: '#a42137',
      90: '#851a2d',
      100: '#661422',
    },
    accentColorV6: {
      10: '#fffaf2',
      20: '#fff3e3',
      30: '#fedaaa',
      40: '#fec272',
      50: '#fdaa39',
      60: '#fc9100',
      70: '#d77c00',
      80: '#b16600',
      90: '#8c5100',
      100: '#663b00',
    },
    neutralScale: {
      0: '#ffffff',
      1: '#fafbfc',
      2: '#f4f6f9',
      3: '#eaeff4',
      4: '#d6dee5',
      5: '#bac6d8',
      6: '#a5b3c8',
      7: '#91a1b7',
      8: '#7c8da5',
      9: '#61738e',
      10: '#4d607d',
      11: '#324766',
      12: '#1a2c47',
      13: '#0e1e38',
      14: '#021028',
    },
    backgroundColor: {
      bodyBackground: '#ffffff',
      lightBackgroundShade1: '#fafbfc',
      lightBackgroundShade2: '#f4f6f9',
      lightBackgroundShade3: '#eaeff4',
      disabledBackground: '#d6dee5',
      backgroundCover: '#0e1e38',
      disabledForeground: '#a5b3c8',
      footerBackground: '#0e1e38',
    },
    fontColor: {
      default: '#61738e',
      light: '#ffffff',
      disabled: '#91a1b7',
      hint: '#61738e',
    },
    linkColor: '#0f87ff',
    borderColor: '#d6dee5',
    formFieldColor: '#f4f6f9',
    shadowColor: '#d6dee5',
  },
  fontSize: {
    titleFont1: '5.6rem',
    titleFont2: '4.8rem',
    titleFont3: '4rem',
    h1Size: '3.2rem',
    h2Size: '2.4rem',
    h3Size: '2rem',
    h4Size: '1.6rem',
    h5Size: '1.4rem',
    h6Size: '1.2rem',
    bodyFontSize: '1.6rem',
    overlineFontSize: '1.6rem',
    overlineSmallFontSize: '1.4rem',
    spareFontSize: '1rem',
    paragraphSize1: '2rem',
    paragraphSize2: '1.8rem',
    paragraphSize3: '1.6rem',
    paragraphSize4: '1.4rem',
  },
  fontWeight: {
    light: 300,
    normal: 400,
    bold: 700,
  },
  lineHeight: {
    paragraphLineHeight1: '3.4rem',
    paragraphLineHeight2: '3.2rem',
    paragraphLineHeight3: '2.9rem',
    paragraphLineHeight4: '2.6rem',
  },
  spacing: {
    xxs: '0.8rem',
    xs: '1.6rem',
    s: '2.4rem',
    m: '3.2rem',
    l: '4rem',
    xl: '6.4rem',
    xxl: '8rem',
    xxl2: '12rem',
  },
  fontFamily: `'Source Sans Pro', sans-serif;`,
  borderRadius: '0.4rem',
};

export default DEFAULT_THEME;
